import type { SocialType } from '@uefacom-newdev/liveblog-integration-react';
import { PkButton } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useCookieConsent } from '../hooks/useCookieConsent';
import Image from '../Image';
import { useTranslateFn } from '../Translate';

import type { CookieCategory } from '@shared-types/optanon.types';

import * as classes from './styles.module.scss';

const CookiePlaceholder = ({
  text = 'cookie_placeholder_text',
  socialType,
  groupId,
}: {
  text?: string;
  socialType?: SocialType;
  groupId: CookieCategory;
}) => {
  const t = useTranslateFn();
  const accepted = useCookieConsent(groupId);

  const acceptAll = () => {
    const acceptButton = document.querySelector<HTMLElement>('.accept-cookies-button');
    if (acceptButton && acceptButton.click) acceptButton.click();
    else if (window.Optanon) window.Optanon.AllowAll();
  };

  const showCookieSettings = () => {
    if (window.Optanon) {
      window.Optanon.ToggleInfoDisplay();
      window.Optanon.TriggerGoogleAnalyticsEvent('OneTrust Cookie Consent', 'Banner Open Preferences');
    }
  };

  return accepted ? null : (
    <div className={classes.placeholder} pk-theme='dark'>
      {socialType && (
        <Image
          className={classes.logo}
          src={`${window.imgBaseUrl}/imgml/uefacom/elements/social/${socialType}` + '.svg'}
        />
      )}
      <div className={classes.text}>{t('we_are_sorry')}</div>
      <div className={classes.text}>{t(text)}</div>
      <PkButton className={classes.acceptButton} onClick={acceptAll}>
        {t('cookie_accept_all')}
      </PkButton>
      <div className={classes.policyContainer}>
        <button type='button' className={classes.policyLink} onClick={showCookieSettings}>
          {t('cookie_settings')}
        </button>
        <a className={classes.policyLink} href='/cookiepolicy/'>
          {t('cookie_policy_link')}
        </a>
      </div>
    </div>
  );
};

export default memo(CookiePlaceholder);
